module.exports = __webpack_public_path__ + "img/pic_noOrders.1775439203884.png";